import { useTranslation } from "react-i18next";

const useTable = ({ params, setParams }) => {
  const { t } = useTranslation(["customer"]);

  const columnTable = [
    {
      dataField: "display_name",
      text: t("sale_support_table.display_name"),
      sort: true,
      formatter: (_cell, row) => {
        return row?.sale?.display_name;
      },
    },
    {
      dataField: "username",
      text: t("sale_support_table.username"),
      sort: true,
      formatter: (_cell, row) => {
        return row?.sale?.username;
      },
    },
    {
      dataField: "email",
      text: t("sale_support_table.email"),
      sort: true,
      formatter: (_cell, row) => {
        return row?.sale?.email;
      },
    },
    {
      dataField: "sale_team",
      text: t("sale_support_table.sale_team"),
      sort: true,
      formatter: (_cell, row) => {
        return row?.sale?.department_name;
      },
    },
  ];

  const onTableChange = (_type, value) => {
    setParams(prev => ({
      ...prev,
      page: value.page,
      sizePerPage: value.sizePerPage,
      sort: `${value.sortOrder}${value.sortField}`,
    }));
  };

  const onSearchAllHandle = value => {
    setParams(prev => ({
      ...prev,
      searchContent: value,
    }));
  };

  return {
    columnTable,
    onTableChange,
    onSearchAllHandle,
  };
};

export default useTable;
